module.exports = __webpack_public_path__ + "img/separator10.de4d892a.svg";